import React from 'react';
import { fetchAllWooLocationPages, deleteWooLocationPage, statusChangeLocationPage } from '../../../../actions/locations';
import { fetchConfig } from "../../../../actions/configuration";
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import history from "../../../../history.js";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { NavLink } from 'react-router-dom';
import { Loader } from '../../../../components/loader';
import { BreadCrumb } from '../../../../components/breadcrumb';
import moment from 'moment';
import { Activity } from '../../../../components/activity';
import { convertToTitleCase } from '../../../../utils/helper.js';
import _ from 'lodash';
const $ = window.$;
var toaOptions = {};

const { SearchBar } = Search;

const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
}

const LOCATION_PAGE_STATUS = {
  PUBLISH : 'publish',
  DRAFT : 'draft'
};

class WooBreeds extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    confirmDelete: false,
    contentData: [],
    selected: [],
    loading: false,
    deleteId: null,
    user_role:'',
    clickedId: '',
    pdfOldVersion: false,
    deletePage: null,
    selectedLocationPagedId: null,
    loadingPublishPage : false,
  };

  tableHeaderColumnData = [
    {
      dataField: 'actions', text: 'Actions', formatter: this.buttonFormatter.bind(this),
      style:{
        'overflowX':'visible'
      }
    },
    {
      dataField: 'post_title', text: 'Page Title', sort: true
    },
    {
      dataField: 'guid', text: 'Page Url', sort: true, formatter: cell => <a href={cell.replace("#038;", "&")} target="_blank">{cell.replace("#038;", "&")}</a>
    },
    {
      dataField: 'post_date', type: 'date', text: 'CreatedAt', formatter: cell => moment(cell).format('MM-DD-YYYY'), sort: true, 
    },
    {
      dataField: 'post_status', type: 'date', text: 'Status',
      sort: true,       
      
      formatter: (cell, row) => {
        return (
          <div>
          { cell === 'draft'?
            <div>
            <span
              className="m-badge mx-auto my-0 px-2 m-badge--wide"           
            >
              <a
              href='#'
              onClick={()=>{ this.pageStatusChangeConfirmation(row,'publish') }}
              >
                <strong>{convertToTitleCase(cell)}</strong>  
              </a>
                   
            </span> 
          </div>: 
            cell === 'publish' ?
           <div>
            <span
              className="m-badge mx-auto my-0 px-2 m-badge--success"           
            >
            <a
              href='#'
              onClick={()=>{ this.pageStatusChangeConfirmation(row,'draft') }}
              className= "text-white"
              >
                <strong>{convertToTitleCase(cell)}</strong>  
              </a>
                       
              </span> 
           </div>:''
          }  
          </div>
        );      
    }
   },
  ];

  buttonFormatter(cell, row) {
    return (
        <span className="dropdown show">
            <span className="dropdown">
              <a href="" className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="true">
                <i className="la la-ellipsis-h"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">  
               <NavLink
                to={`/location/pages/view/${row.ID}`}
                className="dropdown-item"
                title="View"
               >
                <i className="la la-edit"></i> Edit
               </NavLink>    
                <a className="dropdown-item" onClick={(e) => this.deletePopUp(e, row.ID) }>
                  <i className="la la-trash-o"></i> Delete 
                </a>
              </div>
            </span>
        </span>
    );
  }

  pageStatusChangeConfirmation(row,status){
     console.log('=========row======',row);
     if(row && row.ID){
      this.setState({ selectedLocationPagedId : row.ID, locationPageStatus : status});
      $('#confirm_status_change_modal').modal('show');
     }
  } 

  submitPagePablish(){
  let postId = this.state.selectedLocationPagedId;
  let data = { status : this.state.locationPageStatus };

  console.log('==========Status======',postId,data);
  this.setState({ loadingPublishPage : true });
  this.props.statusChangeLocationPage(postId,data);

  }

  componentDidMount() { 
    this.props.fetchAllWooLocationPages();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.data.wooLocationReducer.wooLocationPages && !_.isEqual(nextProps.data.wooLocationReducer.wooLocationPages, this.props.data.wooLocationReducer.wooLocationPages)) {
      this.props.fetchAllWooLocationPages();
    }

    if (nextProps.data.wooLocationReducer.wooLocationPages && nextProps.data.wooLocationReducer.wooLocationPages !== this.props.data.wooLocationReducer.wooLocationPages) {
      let records = nextProps.data.wooLocationReducer.wooLocationPages;
      this.setState({ contentData: records });
    }

    if (nextProps.data.wooLocationReducer.deleteWooSeoPage && nextProps.data.wooLocationReducer.deleteWooSeoPage !== this.props.data.wooLocationReducer.deleteWooSeoPage) {
      //this.props.fetchAllWooLocationPages();
      NotificationManager.success("Page deleted successfully");
      this.setState({loading:false, deletePage: null})
      this.props.fetchAllWooLocationPages();
      $("#confirm_delete_modal").modal("hide");
    }

    if (nextProps.data.wooLocationReducer.statusChangeWooLocationPage && nextProps.data.wooLocationReducer.statusChangeWooLocationPage !== this.props.data.wooLocationReducer.statusChangeWooLocationPage) {

      NotificationManager.success("Page status changed successfully");
      this.setState({ loadingPublishPage : false });
      $('#confirm_status_change_modal').modal('hide');
      this.props.fetchAllWooLocationPages();

    }

    if (nextProps.data.wooLocationReducer.statusChangeWooLocationPageError && nextProps.data.wooLocationReducer.statusChangeWooLocationPageError !== this.props.data.wooLocationReducer.statusChangeWooLocationPageError) {

      NotificationManager.error("An error occurred while changing the page status");
      this.setState({ loadingPublishPage : false });
      $('#confirm_status_change_modalonfirm_publish_modal').modal('hide');

    }

    
  }

  componentDidUpdate(prevProps, prevState) {

  }

  handleDeleteConfirm = () => {
    this.props.getDeletable(this.state.selected);
    this.handleClose();
  }

  handleDelete = (selected) => {
    if (!(selected === null || selected === undefined) && selected !== 0) {
      this.setState({ confirmDelete: true, selected });
    }
  }

  deletePopUp(e, id){
    e.preventDefault();
    this.setState({ deletePage: id });
    $("#confirm_delete_modal").modal("show");
  }
  

  deletePage(){
      this.setState({loading: true});
      this.props.deleteWooLocationPage(this.state.deletePage)
  }

  items = [
    {title: 'Location Pages', to: '/location/pages'}
  ]

  render() {
    const { classes, theme } = this.props;
    const { contentData, loadingPublishPage,locationPageStatus } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items}/>
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              
              <div className="m-portlet m-portlet--mobile">
                
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Location Pages
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <NavLink to={`/location/pages/add`} className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                      <span>
                        <i className="la la-plus"></i>
                        <span>
                          New Page
                        </span>
                      </span>
                    </NavLink>
								  </div>
                </div>
                <div className="m-portlet__body">
                <ToolkitProvider                     
                  keyField="id"
                  data={contentData}                      
                  columns={this.tableHeaderColumnData}
                  search
                  defaultSortDirection="asc" 
                  hover={true} 
                  filter={ filterFactory() } 
                >
                      {
                        props => (
                          <div>
                            <div className='px-0 mb-4 search-bar'>
                              <div className='col-lg-3 px-0 inner-addon right-addon'>
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                              </div>
                            </div>                            
                            <BootstrapTable
                              classes="page-table"
                              {...props.baseProps}
                              pagination={ paginationFactory() } 
                            />
                          </div>
                        )
                      }
                  </ToolkitProvider>                  
                </div>
                
              </div>
              <div
                className="modal fade"
                id="confirm_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this page?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loading == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deletePage()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Page publish confirmation modal start */}
                <div
                  className="modal fade"
                  id="confirm_status_change_modal"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="ConfirmationModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Confirm to Page Status change
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <p>{
                          `Are you sure you want to ${locationPageStatus} this page?`
                         }
                        </p>
                      </div>
                      <div className="modal-footer">
                        { loadingPublishPage == false ? (
                          <div>
                            <button
                              type="button"
                              className="btn btn-secondary m-btn--pill mx-2"
                              data-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              onClick={() => this.submitPagePablish()}
                              className="btn btn-primary m-btn--pill"
                            >
                              Confirm
                            </button>
                          </div>
                        ) : (
                            <div className="center-row">
                              <Loader size={50} />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              {/* Page publish confirmation modal end */}
            </div>
          </div>        
        </div>        
      </div>
    );
  }
}


const mapStateToProps = state => ({
  data: state
});

const mapDispatchToProps = dispatch => ({
  fetchAllWooLocationPages: () => {
    dispatch(fetchAllWooLocationPages());
  },
  deleteWooLocationPage: (id) => {
    dispatch(deleteWooLocationPage(id));
  },
  fetchConfig: () => {
    dispatch(fetchConfig());
  },
  statusChangeLocationPage: (id,status) => {
    dispatch(statusChangeLocationPage(id,status));
  }
});

WooBreeds = connect(mapStateToProps, mapDispatchToProps)(WooBreeds);

export default withRouter(WooBreeds);
